<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row class="noAlTope" v-if="cargando">
      <b-col class="text-center">
        <b-button variant="primary" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </b-col>
    </b-row>

    <div v-else>
      <div v-if="mostrarTratamientos" class="noAlTope">
        <b-row>
          <b-col v-if="cargandoImprimir">
            <b-button variant="primary" disabled>
              <b-spinner small></b-spinner>
              Cargando...
            </b-button>
          </b-col>
          <b-col v-if="!cargandoImprimir">
            <b-button variant="outline-warning" v-on:click="imprimirRecibo">
              Imprimir presupuesto
            </b-button>
          </b-col>
          <b-col v-if="!cargandoImprimir">
            <b-button
              variant="outline-primary"
              v-on:click="guardarTratamientos"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>

        <div>
          <h5 class="mt-4 text-center">
            Tu salud dental (se ve afectada con base a los tratamientos que el
            paciente elija)*
          </h5>

          <b-card
            border-variant="info"
            header-class="subtitulos"
            header="COMPLEMENTOS"
            no-body
            class="mb-4"
          >
            <b-card-body>
              <b-card-text>
                <v-select
                  v-if="$localStorageService.can('PR_04_agregar_complem')"
                  :options="listaComplementos"
                  v-model="seleccionadoComplemento"
                  label="nombreTratamiento"
                  @input="calcularCotizacionComplemento"
                  multiple
                ></v-select>
              </b-card-text>
            </b-card-body>
          </b-card>

          <b-row class="text-center mb-4" v-if="cargandoComplementos">
            <b-col>
              <b-button variant="primary" disabled>
                <b-spinner small></b-spinner>
                Cargando...
              </b-button>
            </b-col>
          </b-row>

          <b-container
            v-if="seleccionadoComplemento.length && !cargandoComplementos"
            class="mb-4"
          >
            <b-table
              thead-tr-class="columnas"
              :items="seleccionadoComplemento"
              :fields="tituloComplemento"
              responsive
            >
              <template v-slot:cell(cantidad)="row">
                <div
                  v-on:dblclick="row.item.editar = true"
                  v-if="!row.item.editar"
                >
                  {{ row.item.cantidad }}
                </div>
                <div v-if="row.item.editar">
                  <b-form-input
                    id="cambioDeCantidad"
                    v-model.number="row.item.cantidad"
                    v-on:keyup.enter="
                      row.item.editar = false;
                      $emit('update');
                    "
                  ></b-form-input>
                </div>
              </template>


              <template v-slot:cell(costoUnitario)="row">
                {{ row.item.costoUnitario | moneda }}
              </template>
              <template v-slot:cell(descuentoVale)="row">
                {{ row.item.descuentoVale | moneda }}
              </template>
              <template v-if="item.idPacienteVale == null" v-slot:cell(descuentoVale)="row">
                {{ row.item.descuentoVale }} %
              </template>
              <template v-if="item.idPacienteVale && item.descuentoVale==row.item.costoUnitario" v-slot:cell(descuentoVale)="row">
              {{ row.item.descuentoVale }} GRATIS
            </template>
              <template v-slot:cell(costoSesion)="row">
                {{ row.item.costoSesion | moneda }}
              </template>
              <template v-slot:cell(precioTotal)="row">
                {{ (row.item.cantidad * row.item.costoSesion) | moneda }}
              </template>
            </b-table>
          </b-container>

          <div>
            <b-table-simple hover responsive>
              <b-thead class="columnas">
                <b-tr>
                  <b-th class="text-center">OD</b-th>
                  <b-th>Diagnóstico</b-th>
                  <b-th>Tratamiento</b-th>
                  <b-th>Cantidad</b-th>
                  <b-th class="text-right">Costo unitario</b-th>
                  <b-th class="text-center">Descuento</b-th>
                  <b-th class="text-center">Descuento Promoción</b-th>
                  <b-th class="text-right">Costo por sesion</b-th>
                  <b-th>No. Sesiones de Pago</b-th>
                  <b-th>No. Sesiones de Tratamiento</b-th>
                  <b-th class="text-center">Tipo de padecimiento</b-th>
                  <b-th class="text-center">Estatus</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="(padecimiento, index) in seleccionPlanTratamientos"
                  :key="index"
                >
                  <b-td class="text-center">
                    {{ padecimiento.numeroDiente }}
                  </b-td>
                  <b-td>{{ padecimiento.diagnostico }}</b-td>

                  <b-td>
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                          v-for="(trts, indice) in padecimiento.tratamientos"
                          :key="indice"
                        >
                          <b-td>{{ trts.nombreTratamiento }}
                            <tag-promocion
                                v-if="trts.promocion === null && !trts.aceptar"
                                :promociones.sync="promociones"
                                :tratamiento.sync="trts"
                            >
                            </tag-promocion>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>

                  <b-td>
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                            v-for="(trts, indice) in padecimiento.tratamientos"
                            :key="indice"
                        >
                          <b-td>{{ trts.cantidad }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>

                  <b-td class="text-right">
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                          v-for="(trts, indice) in padecimiento.tratamientos"
                          :key="indice"
                        >
                          <b-td>{{ trts.costoUnitario | moneda }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>

                  <b-td class="text-center">
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                            v-for="(trts, indice) in padecimiento.tratamientos"
                            :key="indice"
                        >
                          <b-td>
                            <span v-if="idPacienteVale != null && trts.montoDescuento > 0 && trts.montoDescuento < trts.costoUnitario">{{ trts.montoDescuento | moneda }}</span>
                            <span v-else-if="idPacienteVale != null && trts.montoDescuento == trts.costoUnitario">Gratis</span>
                            <span v-else-if="idPacienteVale == null && trts.descuento > 0">{{ trts.descuento }} %</span>
                            <span v-else >-</span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>
                  <b-td class="text-center">
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                            v-for="(trts, indice) in padecimiento.tratamientos"
                            :key="indice"
                        >
                          <b-td>
                            <span v-if="trts.promocion != null">{{Math.floor( trts.promocion.descuento) }}% <em   v-if="!trts.aceptar && trts.promocion.promocionForzosa == false" class="fa fa-close botoncito" @click="quitarPromo(trts)"></em></span>
                            <span v-else >-</span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>

                  <b-td class="text-right">
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                            v-for="(trts, indice) in padecimiento.tratamientos"
                            :key="indice"
                        >
                          <b-td>
                            <span v-if="trts.promocion != null && trts.promocion.descuento != null && !trts.bloqueado">
                              {{Math.round(trts.costoSesion -( trts.costoSesion*trts.promocion.descuento /100))   | moneda }}
                            </span>
                            <span v-else>
                              {{trts.costoSesion | moneda }}
                            </span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>

                  <b-td>
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                          v-for="(trts, indice) in padecimiento.tratamientos"
                          :key="indice"
                        >
                          <b-td>{{ trts.numeroSesiones }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>

                  <b-td>
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                            v-for="(trts, indice) in padecimiento.tratamientos"
                            :key="indice"
                        >
                          <b-td>{{ trts.numeroSesionesTratamiento }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>



                  <b-td class="text-center">
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                          v-for="(trts, indice) in padecimiento.tratamientos"
                          :key="indice"
                        >
                          <b-td
                            v-if="trts.tipoPadecimiento === 'INDISPENSABLE'"
                          >
                            <strong>Indispensable</strong>
                          </b-td>
                          <b-td
                            style="color: red"
                            v-else-if="trts.tipoPadecimiento === 'INFECCIOSO'"
                          >
                            <strong>Infeccioso</strong>
                          </b-td>
                          <b-td
                            style="color: orange"
                            v-else-if="trts.tipoPadecimiento === 'FUNCIONAL'"
                          >
                            <strong>Funcional</strong>
                          </b-td>
                          <b-td style="color: green" v-else>
                            <strong>Estéticos</strong>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>
                  <b-td>
                    <b-table-simple small>
                      <b-tbody>
                        <b-tr
                          v-for="(trts, indice) in padecimiento.tratamientos"
                          :key="indice"
                        >
                          <b-td>
                            <b-button
                              variant="outline-primary"
                              size="sm"
                              v-if="trts.bloqueado"
                              :disabled="trts.bloqueado"
                              v-on:click="trts.aceptar = false"
                            >
                              Existente
                            </b-button>
                            <div v-else>
                              <b-button
                                variant="primary"
                                size="sm"
                                v-if="trts.aceptar"
                                v-on:click="trts.aceptar = false"
                              >
                                Aceptado
                              </b-button>
                              <b-button
                                variant="danger"
                                size="sm"
                                v-else
                                v-on:click="trts.aceptar = true"
                              >
                                Denegado
                              </b-button>
                            </div>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </div>
      <div class="noAlTope" v-else>
        <b-alert variant="danger" show>No hay tratamientos de este pti</b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";
import TagPromocion from "../../components/promocion/TagPromocion";
import {PromocionesService} from "../../apiServices/promociones/PromocionesService";
import {NuevoM2Service} from "@/apiServices/pti/NuevoM2Service";

export default {
  name: "PresupuestoSinSDI",
  components: {TagPromocion},
  props: {
    ptiCId: {
      type: String,
      required: true,
    },
    idPaciente: {
      type: String,
      required: true,
    },
    ptiId: null,
    nombreCompleto: {
      type: String,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    mostrarTratamientos: false,
    seleccionPlanTratamientos: [],
    cargandoImprimir: false,
    cargandoComplementos: false,
    cargando: true,
    idClinica: null,
    listaComplementos: [],
    tituloComplemento: [
      {
        key: "nombreTratamiento",
        label: "nombre",
      },
      {
        key: "cantidad",
        label: "cantidad",
      },
      {
        key: "costoUnitario",
        label: "Precio original",
      },
      {
        key: "descuento",
        label: "Descuento",
      },
      {
        key: "costoSesion",
        label: "precio",
      },
      {
        key: "precioTotal",
        label: "precioTotal",
      },
    ],
    idPlan: null,
    idPacienteVale: null,
    nombreVale: null,
    seleccionadoComplemento: [],
    promociones: [],
    promocionesServicio: new PromocionesService(),
    nuevoM2Service: new NuevoM2Service(),
  }),
  mounted(){
    this.traerTratamientoProgramados();

  },

  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idClinica = this.$localStorageService.getIdClinica();
    this.traerComplementos();
    this.obtenerPromociones();
  },
  methods: {
    obtenerPromociones(){
      const fecha = this.$moment(new Date()).format('DD/MM/YYYY');
      const datos = {
        fecha: fecha,
        idClinica: this.idClinica,
        idPti: this.ptiId,
        opcio: 1
      }
      this.promocionesServicio.obtenerPromocionesPorPtiParaSDI(datos)
          .then(respuesta => {
            this.promociones = respuesta
          })
    },
    quitarPromo(item){
      this.promociones.forEach( p => {
        if (p.idPromocion === item.promocion.idPromocion){
          p.seleccionado = false;
        }
      })
      item.promocion = null
    },
    traerTratamientoProgramados() {
      this.cargando = true;
      const params = {
        idPti: this.ptiId,
        idUsuario: this.$localStorageService.getIdUsuario()
      }
      const url = this.$api + "pti/tratamientos/sinSdi";
      this.$http
        .post(url, params)
        .then((response) => {
          if (response.data.data) {
            if (response.data.data.length != 0) {
              this.mostrarTratamientos = true;
            }
            this.seleccionPlanTratamientos = response.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    traerComplementos() {
      const url = this.$api + "catalogos/listaComplementos";

      const parametros = {
        idClinica: this.idClinica,
        idPti: this.ptiId,
        idPaciente: this.idPaciente,
      };

      this.$http
        .post(url, parametros)
        .then((response) => {
          if (response.data.data) {
            response.data.data = response.data.data.map((e) => ({
              ...e,
              editar: false,
            }));

            this.listaComplementos = response.data.data;
          }
        })
        .catch((error) => {
          this.errorMensaje(error);
        });
    },
    imprimirRecibo() {
      this.cargandoImprimir = true;
      const parametros = {
        idPti: this.ptiId,
        idClinica: this.idClinica,
      };
      const url = this.$api + "reportes/recibo/presupuesto";
      this.$http
        .post(url, parametros)
        .then((response) => {
          if (response.data.data) {
            this.cargandoImprimir = false;
            const datos = response.data.data;
            const fecha = this.$moment(new Date()).format('l')
            const newDate = fecha.split("/")
            var dia = newDate[0];
            var mes = newDate[1];
            var anio = newDate[2];
            const nombre = "PresNoSDI_" + this.nombreCompleto + "_" + dia + "_" + mes + "_" + anio;
            this.descargar(datos, nombre);
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargandoImprimir = false;
        });
    },
    descargar(datos, nombre) {
      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombre;
      link.click();
    },
    calcularCotizacionComplemento() {
      this.cargandoComplementos = true;

      let listaTratamientos = [];
      this.seleccionadoComplemento.forEach((i) => {
        listaTratamientos.push(i.idTratamiento);
      });

      const datosGenerales = {
        listaTratamientos: listaTratamientos,
        idClinica: this.idClinica,
        idPti: this.ptiId,
        idPaciente: this.idPaciente,
      };

      const urlTProgramados = this.$api + "catalogos/listaComplementosDetalle";
      this.$http
        .post(urlTProgramados, datosGenerales)
        .then((response) => {
          if (response.status === 200) {
            response.data.data = response.data.data.map((e) => ({
              editar: false,
              ...e,
            }));
            this.seleccionadoComplemento = response.data.data;
          }
        })
        .catch((error) => {
          this.showErrorComplementos(error);
        })
        .finally(() => {
          this.cargandoComplementos = false;
        });
    },
    guardarTratamientos() {
      this.cargandoImprimir = true;
      const url = this.$api + "pti/tratamientos";

      this.$http
        .post(url, this.traerDatos())
        .then((response) => {
          if (response.data.data) {
            this.guardarComplementos();
          }
        })
        .catch((err) => {
          this.cargandoImprimir = false;
          this.errorEnvio(err);
        });
    },
    traerDatos() {
      let lista = [];

      this.seleccionPlanTratamientos.forEach((i) => {
        i.tratamientos.forEach((j) => {
          if (j.aceptar && !j.bloqueado) {
            lista.push({
              diente: i.diente,
              tratamiento: j.idTratamiento,
              idPtiTratamientos: j.idPtiTratamiento,
              cantidad: j.cantidad,
              promocion: j.promocion,
              descuentoPlan: j.descuento,
              idDCalculoDescuentoPlanDetalle: j.idDCalculoDescuentoPlanDetalle,
              precioSesion: j.costoSesion,
              precioOriginalSesion: j.costoUnitario,
              montoDescuento: j.montoDescuento
            });
          }
        });
      });

      return {
        idPti: this.ptiId,
        idClinica: this.idClinica,
        idPaciente: this.idPaciente,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
        opcion: 1,
        listaTratamientos: lista,
      };
    },
    guardarComplementos() {
      const url = this.$api + "diagnostico/complemento/programado";

      this.$http
        .post(url, this.traerDatosComplementos())
        .then((response) => {
          if (response.data.data) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });

            setTimeout(() => location.reload(), 2000);
          }
        })
        .catch((err) => {
          this.errorEnvio(err);
        })
        .finally(() => {
          this.cargandoImprimir = false;
        });
    },
    traerDatosComplementos() {
      let lista = [];
      this.seleccionadoComplemento.forEach((it) => {
        lista.push({
          idTratamiento: it.idTratamiento,
          idCompania: 1,
          cantidad: it.cantidad,
          precio: it.costoSesion,
          idTipoTratamiento: it.idTipoTratamiento,
        });
      });

      return {
        complementos: lista,
        idPti: this.ptiId,
        idUsuarioLog: this.$localStorageService.getIdUsuario(),
        idClinica: this.idClinica,
        idPaciente: this.idPaciente,
        opcion: 1,
        sdi: false,
      };
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>

<style scoped>
#cambioDeCantidad {
  width: 150px;
  border: 3px solid salmon;
}
</style>
